import request from '@/utils/request'

// 创建分组
export const addGcashGroup = (data: any) =>
  request({
    url: '/manage/gcash-groups',
    method: 'post',
    data
  })

// 获取单个分组
export const getOneGcash = (params: any) =>
  request({
    url: '/manage/gcash-groups/' + params.id,
    method: 'get'
  })

// 获取所有分组
export const getAllGcash = (params: any) =>
  request({
    url: '/manage/gcash-groups',
    method: 'get',
    params
  })

// 删除单个分组
export const delGcashGroup = (data: any) =>
  request({
    url: '/manage/gcash-groups/' + data.id,
    method: 'delete'
  })

// 更改一个分组
export const setGcashGroup = (data: any) =>
  request({
    url: '/manage/gcash-groups/' + data.id,
    method: 'patch',
    // data: data.obj
    data
  })
